<template>
  <img
    ref="img"
    @load="loaded"
    :class="previewClass"
    :src="previewData.preview_path"
  />
</template>

<script>
import Bus from "@/utils/bus";
export default {
  name: "imgPreview",
  data() {
    return {};
  },
  created() {
    // console.log("初始化imgPreview预览组件");
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    },
  },
  methods: {
    // 设置为原始尺寸
    originalSize() {
      let img = this.$refs.img;
      img.style.width = this.naturalWidth + "px";
      img.style.height = this.naturalHeight + "px";
    },
    // 初始化图片的尺寸
    initWidthHeight() {
      let maxWidth = window.innerWidth;
      let maxHeight = window.innerHeight - 40;
      let img = this.$refs.img;
      if (this.naturalWidth > 0 && this.naturalHeight > 0) {
        //原图片宽高比例 大于 指定的宽高比例，这就说明了原图片的宽度必然 > 高度
        if (this.naturalWidth / this.naturalHeight >= maxWidth / maxHeight) {
          if (this.naturalWidth > maxWidth) {
            img.style.width = maxWidth + "px";
            // 按原图片的比例进行缩放
            img.style.height =
              (this.naturalHeight * maxWidth) / this.naturalWidth + "px";
          } else {
            // 按原图片的大小进行缩放
            img.style.width = this.naturalWidth + "px";
            img.style.height = this.naturalHeight + "px";
          }
        } else {
          // 原图片的高度必然 > 宽度
          if (this.naturalHeight > maxHeight) {
            img.style.height = maxHeight + "px";
            // 按原图片的比例进行缩放
            img.style.width =
              (this.naturalWidth * maxHeight) / this.naturalHeight + "px";
          } else {
            // 按原图片的大小进行缩放
            img.style.width = this.naturalWidth + "px";
            img.style.height = this.naturalHeight + "px";
          }
        }
      }
    },
    loaded() {
      // 仅当在搜索预览中可以自适应图片大小，其他都是根据css固定设置
      if (this.previewData.position === "fullscreen-top") {
        let image = new Image();
        image.src = this.previewData.preview_path;
        image.onload = () => {
          this.naturalWidth = image.width;
          this.naturalHeight = image.height;
          this.initWidthHeight();
        };
      }
    },
    MouseWheelHandler(e) {
      let img = this.$refs.img;
      let el = window.event || e;
      let delta = Math.max(-1, Math.min(1, el.wheelDelta || -el.detail));

      let maxWidth = window.innerWidth;
      let maxHeight = window.innerHeight - 40;
      if (this.naturalWidth > 0 && this.naturalHeight > 0) {
        if (this.naturalWidth / this.naturalHeight >= maxWidth / maxHeight) {
          // 原图片宽高比例 大于 指定的宽高比例，以maxWidth为自适应宽度
          let width = delta > 0 ? img.width * 1.1 : img.width * 0.9;
          if (width < this.naturalWidth && width < 30) {
            width = 30;
          }
          if (width < maxWidth || width < this.naturalWidth * 1.5) {
            img.style.width = width + "px";
            img.style.height =
              (this.naturalHeight * width) / this.naturalWidth + "px";
          } else {
            img.style.width = maxWidth + "px";
            img.style.height =
              (this.naturalHeight * maxWidth) / this.naturalWidth + "px";
          }
        } else {
          // 原图片宽高比例 小于 指定的宽高比例，以maxHeight为自适应宽度
          let height = delta > 0 ? img.height * 1.1 : img.height * 0.9;
          if (height < this.naturalHeight && height < 30) {
            height = 30;
          }
          if (height < maxHeight || height < this.naturalHeight * 1.5) {
            img.style.height = height + "px";
            img.style.width =
              (this.naturalWidth * height) / this.naturalHeight + "px";
          } else {
            img.style.height = maxHeight + "px";
            img.style.width =
              (this.naturalWidth * height) / this.naturalHeight + "px";
          }
        }
      }
      return false;
    },
  },
  mounted() {
    // 仅当搜索预览的时候才可以缩放图片
    if (this.previewData.position === "fullscreen-top") {
      this.imgParent = this.$refs.img.parentNode;
      if (this.imgParent.addEventListener) {
        // IE9, Chrome, Safari, Opera
        this.imgParent.addEventListener(
          "mousewheel",
          this.MouseWheelHandler,
          false
        );
        // Firefox
        this.imgParent.addEventListener(
          "DOMMouseScroll",
          this.MouseWheelHandler,
          false
        );
      } else {
        // IE 6/7/8
        this.imgParent.attachEvent("onmousewheel", this.MouseWheelHandler);
      }
      // 设置原始尺寸
      Bus.$on("originalSize", this.originalSize);
      Bus.$on("initWidthHeight", this.initWidthHeight);
    }
  },
  destroyed() {
    // console.log("销毁imgPreview预览组件");
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview",
    });
    Bus.$off("originalSize");
    Bus.$off("initWidthHeight");
  },
};
</script>

<style scoped>
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) !important;
  transform: translate(-50%, -50%) !important;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>